module.exports = __webpack_public_path__ + "static/media/axerweb_logo-fundo-claro.9e28eb44.png";